import React from 'react'
import { Tooltip } from 'react-tippy'

export default function Dot ({
  x,
  y,
  title,
  text
}) {

  if (!text && !title) {
    return null
  }

  const TippyContent = () => {
    return (
      <>
        {title && <p className="mtt-iu-dot__tooltip-title">{title}</p>}
        {text && <p className="mtt-iu-dot__tooltip-text">{text}</p>}
      </>
    )
  }

  return (
    <div className="mtt-iu-dot" style={{ left: x + '%', top: y + '%' }}>
      <Tooltip
        position="top-start"
        theme="iu-light"
        html={ <TippyContent/> }
        className="mtt-iu-dot__tooltip"
      >
        <div className="mtt-iu-dot__dot"/>
        <div className="mtt-iu-dot__hover-element"/>
      </Tooltip>
    </div>
  )
}
